import { render, staticRenderFns } from "./TasksPreview.vue?vue&type=template&id=2f6f3484&"
import script from "./TasksPreview.vue?vue&type=script&lang=js&"
export * from "./TasksPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports